module.exports = __webpack_public_path__ + "static/women-9e259641fe97b5495a8c0f0c3e416374.svg";